import { render, staticRenderFns } from "./appAd.vue?vue&type=template&id=220fe6dc&scoped=true&"
import script from "./appAd.vue?vue&type=script&lang=js&"
export * from "./appAd.vue?vue&type=script&lang=js&"
import style0 from "./appAd.vue?vue&type=style&index=0&id=220fe6dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220fe6dc",
  null
  
)

export default component.exports